import React, { useState, useRef, useEffect } from "react";
import { FaAngleLeft, FaAngleRight } from "react-icons/fa6";
import axios from "axios";
import { toast } from "react-toastify";
import BaseUrl from "../../base-api";
import { Link, useNavigate } from "react-router-dom";
import file from "../../assets/sampledata.xlsx";
import Loader from "../Loader/Loader";
import moment, { now } from "moment";
import { makeKey } from "../CustomUtils";

const Renewal = () => {
    const [notifications, setNotifications] = useState([]);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const [bankData, setBankData] = useState(null);

    const [viewNotifications, setViewNotifications] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(5);
    const [totalItems, setTotalItems] = useState(0);
    const [searchQuery, setSearchQuery] = useState("");
    const [state, setState] = useState([]);
    const [programs, setPrograms] = useState([]);
    const [district, setDistrict] = useState([]);
    const initialState = {
        state: "",
        program: "",
        district: "",
        file: null
    };
    const [formData, setFormData] = useState(initialState);

    // Modal states
    const [showModal, setShowModal] = useState(false);
    const [modalPrograms, setModalPrograms] = useState([]);
    const [modalMobile, setModalMobile] = useState("");
    const [modalSelected, setModalSelected] = useState(new Set());

    const data = async () => {
        setLoading(true);
        try {
            const token = sessionStorage.getItem("userToken");
            if (!token) {
                navigate("/login");
                return;
            }
            const res = await axios.get(`${BaseUrl}/api/reg/registrationDto`, {
                headers: {
                    'Content-Type': "application/json"
                },
            });
            if (res) {
                console.log(res.data)
                setState(res.data.state);
                setPrograms(res.data.programs);
            }
        } catch (error) {
            console.log(error.response?.data?.message);
        } finally {
            setLoading(false);
        }
    };
    const initiatePayment = async (mobileNumber, programCode) => {
        setLoading(true)
        try {
            const key = makeKey(mobileNumber, programCode);
            let selected = [];
            selected.push(key)
            const token = sessionStorage.getItem("userToken")
            const res = await axios.post(`${BaseUrl}/api/pay/initiateBulk`, selected, {

                headers: {
                    'Content-Type': "application/json",
                    Authorization: token,
                },

            });

            if (res) {
                toast.success("Redirecting you to payment screen...");
                setBankData(res.data);
                setTimeout(() => {
                    document.forms["payuForm"].submit();
                }, 500);
            }


        } catch (error) {
            toast.error(error.response?.data?.message);
        }
        finally {
            setLoading(false);
        }
    }

    const fetchData = async () => {
        setLoading(true);
        try {
            const token = sessionStorage.getItem("userToken");
            const res = await axios.get(`${BaseUrl}/api/adm/all-renew`, {
                params: { page: 0, size: 10 },
                headers: {
                    'Content-Type': "application/json",
                    Authorization: token,
                },
            });
            if (res) {
                setNotifications(res.data.data.content);
                setTotalItems(res.data.data.content.length);
            }
        } catch (error) {
            console.log(error.response?.data?.message);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        data();
        fetchData();
    }, []);

    useEffect(() => {
        setViewNotifications(notifications.slice(0, itemsPerPage));
    }, [notifications]);
    useEffect(() => {
        if (showModal == false) {
            setFormData(initialState);
        }
    }, [showModal]);

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
        const startIndex = (pageNumber - 1) * itemsPerPage;
        const endIndex = pageNumber * itemsPerPage;
        setViewNotifications(notifications.slice(startIndex, endIndex));
    };

    const handleNextPage = () => {
        if (currentPage * itemsPerPage < totalItems) {
            handlePageChange(currentPage + 1);
        }
    };

    const handlePreviousPage = () => {
        if (currentPage > 1) {
            handlePageChange(currentPage - 1);
        }
    };


    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevFormData) => ({
            ...prevFormData,
            [name]: value,
        }));
    };

    // Modal logic
    const fetchUserPrograms = async (mobileNumber) => {
        setModalPrograms([])
        setLoading(true);
        try {
            const token = sessionStorage.getItem("userToken");
            const res = await axios.get(
                `${BaseUrl}/api/adm/all`,
                {
                    params: { mobileNumber },
                    headers: {
                        'Content-Type': "application/json",
                        Authorization: token,
                    },
                }
            );
            if (res && res.data) {
                setModalPrograms(res.data);
                setModalMobile(mobileNumber);
                setShowModal(true);
                setModalSelected(new Set());
            }
        } catch (error) {
            toast.error(error.response?.data?.message || "Failed to fetch programs.");
        } finally {
            setLoading(false);
        }
    };

    const handleModalCheckbox = (programCode) => {
        setModalSelected(prev => {
            const next = new Set(prev);
            if (next.has(programCode)) {
                next.delete(programCode);
            } else {
                next.add(programCode);
            }
            return next;
        });
    };

    const handleModalPay = async (mobileNumber, program) => {
        setLoading(true);
        try {
            const token = sessionStorage.getItem("userToken");
            const store = new FormData();
            store.append("program", program);
            store.append("mobileNumber", mobileNumber);
            const res = await axios.post(
                `${BaseUrl}/api/adm/apply`,
                store,
                {
                    headers: {
                        'Content-Type': "application/json",
                        Authorization: token,
                    },
                }
            );
            if (res) {
                toast.success("Redirecting you to payment screen...");
                setBankData(res.data);
                setTimeout(() => {
                    document.forms["payuForm"].submit();
                }, 500);
                setShowModal(false);
                setModalSelected(new Set());
            }
        } catch (error) {
            toast.error(error.response?.data?.message || "Payment failed.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            {loading ? (
                <Loader />
            ) : (
                <div className="home-dashboard">
                    <div className="ticket-tab">
                        <div className="row mb-4">
                            <div className="col-6">
                                <h3 className=" text-uppercase text-success" style={{ fontWeight: "500" }}>
                                    Manage<span style={{ color: "#20e61b" }}> Students</span>
                                </h3>
                            </div>
                        </div>
                        <table className="table table-striped table-bordered table-hover">
                            <thead>
                                <tr>
                                    <th>Name</th>
                                    <th>State</th>
                                    <th>District</th>
                                    <th>Mobile Number</th>
                                    <th>#</th>
                                </tr>
                            </thead>
                            <tbody>
                                {viewNotifications.length > 0 ? (
                                    viewNotifications.filter((notification) => notification.feeStatus === false).map((notification, index) => {
                                        const key = `${notification.name}-${notification.mobileNumber}-${index}`;
                                        return (
                                            <tr key={key}>
                                                <td>{notification.firstName}{" "}{notification.lastName}</td>
                                                <td>{notification.state}</td>
                                                <td>{notification.district}</td>
                                                <td>{notification.mobileNumber}</td>
                                                <td>
                                                    <button
                                                        className="btn btn-xs btn-warning"
                                                        onClick={() => fetchUserPrograms(notification.mobileNumber)}
                                                    >
                                                        View
                                                    </button>
                                                </td>
                                            </tr>
                                        );
                                    })
                                ) : (
                                    <tr>
                                        <td colSpan={5} className="text-center">
                                            No User Found
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                        <div className="row mt-4">
                            <div className="col-5">Total : {viewNotifications.length} of {totalItems}</div>
                            <div className="col-7 ">
                                <div className="d-flex align-items-center">
                                    <button
                                        style={{ width: "8%", borderRadius: "50%" }}
                                        className="btn btn-success"
                                        onClick={handlePreviousPage}
                                        disabled={currentPage === 1}
                                    >
                                        <FaAngleLeft />
                                    </button>
                                    <div className="mx-3 d-flex">
                                        {Array.from({ length: Math.ceil(totalItems / itemsPerPage) }).map((_, index) => {
                                            const pageNum = index + 1;
                                            if (pageNum === currentPage || pageNum === currentPage - 1 || pageNum === currentPage + 1) {
                                                return (
                                                    <button
                                                        key={pageNum}
                                                        className={`btn mx-1 ${currentPage === pageNum ? "active btn-primary" : "btn-light"}`}
                                                        onClick={() => handlePageChange(pageNum)}
                                                    >
                                                        {pageNum}
                                                    </button>
                                                );
                                            }
                                            return null;
                                        })}
                                    </div>
                                    <button
                                        style={{ width: "8%", borderRadius: "50%" }}
                                        className="btn btn-success"
                                        onClick={handleNextPage}
                                        disabled={currentPage >= Math.ceil(totalItems / itemsPerPage)}
                                    >
                                        <FaAngleRight />
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    {bankData && (
                        <form
                            name="payuForm"
                            action={bankData?.action}
                            method="post"
                            style={{ display: "none" }}
                        >
                            {Object.entries(bankData).map(
                                ([key, value]) =>
                                    key !== "action" && (
                                        <input key={key} type="hidden" name={key} value={value} />
                                    )
                            )}
                        </form>
                    )}
                </div>
            )}

            {showModal && (
                <div
                    style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100vw",
                        height: "100vh",
                        background: "rgba(0,0,0,0.5)",
                        zIndex: 9999,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center"
                    }}
                    onClick={() => setShowModal(false)}
                >
                    <div
                        style={{
                            background: "#fff",
                            padding: "24px",
                            borderRadius: "8px",
                            minWidth: "350px",
                            maxWidth: "90vw",
                            maxHeight: "80vh",
                            overflowY: "auto",
                            boxShadow: "0 2px 8px rgba(0,0,0,0.2)"
                        }}
                        onClick={e => e.stopPropagation()}
                    >
                        <h5>Programs for {modalMobile}</h5>
                        <hr />
                        {/* {modalPrograms.length > 0 ? ( */}
                        <table className="table table-bordered">
                            <thead>
                                <tr>
                                    <th>S. No</th>
                                    <th>Name</th>
                                    <th>Program</th>
                                    <th>Enrolled On</th>
                                    <th>Status</th>
                                </tr>
                            </thead>
                            <tbody>
                                {modalPrograms.map((p, idx) => (
                                    <tr key={idx}>
                                        <td>
                                            {idx + 1}.
                                            {/* {p.status === "Expired" && (
                        <input
                          type="checkbox"
                          checked={modalSelected.has(p.programCode)}
                          onChange={() => handleModalCheckbox(p.programCode)}
                        />
                      )} */}
                                        </td>
                                        <td>{p.firstName} {p.lastName}</td>
                                        <td>{p.program}</td>
                                        <td>{moment(p.enrolledOn).format('DD MMM YYYY')}</td>
                                        <td>{p.paymentEligible ?
                                            (moment(p.enrolledOn).isAfter(moment(now())) ? 'Renew' :
                                                <button
                                                    className="btn btn-sm btn-success"
                                                    onClick={() => initiatePayment(p.mobileNumber, p.programCode)}
                                                >
                                                    Click here to Pay
                                                </button>) : 'Paid'}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                        <div className="form-group my-3 mt-5">
                            <label className="mb-2">Apply for New Program?</label>
                            <div style={{ display: "flex", justifyContent: "flex-end" }}>
                                <div className="col-md-8">
                                    <select className="form-control" name="program" value={formData.program} onChange={(e) => { handleChange(e); }}>
                                        <option value={""}>Select Program...</option>
                                        {programs?.map((item, index) => (
                                            <option key={index} value={item.code} >{item.name}</option>
                                        ))}
                                    </select>
                                </div>
                                <div className="col-md-4">
                                    {formData.program &&
                                        <div style={{ display: "flex", justifyContent: "flex-end" }}>
                                            <button
                                                className="btn btn-success"
                                                onClick={() => handleModalPay(modalMobile, formData.program)}
                                            >
                                                Click here to Pay
                                            </button>
                                        </div>}
                                </div>
                            </div>
                        </div>
                        {/* ) : (
              <div>No programs found.</div>
            )} */}
                        <div style={{ textAlign: "center" }}>
                            <button className="btn btn-secondary mt-2 me-2" onClick={() => setShowModal(false)}>
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default Renewal;